<template>
  <f7-actions>
    <f7-actions-group>
      <f7-actions-label>複製至</f7-actions-label>
    </f7-actions-group>
    <f7-actions-group>
      <f7-actions-button
        v-for="(parent, index) in parents"
        :key="`menu-draft-element-duplicate-actions-${index}`"
        @click="copyElement(parent)">
        <template v-if="parent.parent.parent">
          {{ parent.title || '未命名' }} ({{ parent.parent.parent.title || '未命名' }} > {{ parent.parent.title || '未命名' }}  ) {{ parent.grandparent }}
        </template>
        <template v-else>
          {{ parent.title || '未命名' }} ({{ parent.parent.title || '未命名' }}) {{ parent.grandparent }}
        </template>
      </f7-actions-button>
    </f7-actions-group>
    <f7-actions-group>
      <f7-actions-button color="red" bold>取消</f7-actions-button>
    </f7-actions-group>
  </f7-actions>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import * as R from 'ramda'

const elementSingularTypes = ['category', 'group', 'item', 'question', 'option', 'question', 'option']
const elementPluralTypes = ['categories', 'groups', 'items', 'questions', 'options', 'questions', 'options']

export default {
  name: 'MenuDraftElementDuplicateActionSheet',
  dependencies: ['questionType'],
  data () {
    return {
      parents: []
    }
  },
  props: {
    storeIdProp: String,
    menuDraftVariationProp: String
  },
  created () {
    const { parents } = this.getDescendants(Object.keys(this.currentDraft.categories).map(k => this.currentDraft.categories[k]))
    this.parents = parents
  },
  computed: {
    ...mapState('menuDraftModule', ['currentElementPath', 'currentDraft']),
    elementId () { return this.currentElementPath[this.currentElementPath.length - 1].id },
    parentId () { return this.currentElementPath[this.currentElementPath.length - 2].id },
    parent () { return this.currentDraft[elementPluralTypes[this.currentElementPath.length - 2]][this.parentId] },
    elementIndex () { return this.currentElementPath[this.currentElementPath.length - 1].index }
  },
  methods: {
    ...mapActions('menuDraftModule', ['setGroupProperties', 'setItemProperties', 'setQuestionProperties', 'setOptionProperties']),
    copyElement (parent) {
      const parentType = elementSingularTypes[parent.elementPath.length - 1]
      const singularElementType = elementSingularTypes[parent.elementPath.length - 1]
      const pluralElementType = elementPluralTypes[parent.elementPath.length]
      const properties = R.assoc(pluralElementType, parent[pluralElementType].concat([this.elementId]), {})
      const payload = R.assoc(`${singularElementType}Id`, parent.id, {
        elementLevel: parent.elementPath.length - 1,
        properties,
        elementPath: parent.elementPath.concat({ id: this.elementId, index: this.elementIndex }),
        updateChainOption: {
          copyLevel: parent.elementPath.length - 1
        }
      })
      this[`set${parentType.charAt(0).toUpperCase() + parentType.slice(1)}Properties`](payload)
    },
    getDescendants (elements, generations = this.currentElementPath.length - 2, elementTypeIndex = 1) {
      const children = elements.reduce((children, element, elementIndex) =>
        children
          .concat(element[elementPluralTypes[elementTypeIndex]]
            .map((id, index) =>
              Object.assign({}, this.currentDraft[elementPluralTypes[elementTypeIndex]][id], {
                parent: element,
                elementPath: (element.elementPath || [{ id: element.id, index: elementIndex }]).concat({ id, index })
              }))), [])
      return generations
        ? this.getDescendants(children, generations - 1, elementTypeIndex + 1)
        : {
          parents: elements.filter(e => e.type !== this.questionType.switchQuestion && e.type !== this.questionType.numberGroupQuestion),
          elementTypeIndex
        }
    }
  }
}
</script>
